<template>
  <div class="row">
    <div class="col-md-12">
      <TableWrapper
        name="tbl_parking"
        :columns="columns"
        :mod-count="modCount"
        :url="url"
        :show-del="deletePermitted"
        :search-form-fields="formFields"
        :offset-height="offsetHeight"
        :show-column-visible="true"
        :show-add="addPermited"
        @on-add="showFormModalDialog"
        @on-batch-del="onBatchDeleteDone"
      />
    </div>
    <ParkingDialog
      :id="entityId"
      :visible="modalForm"
      :width="560"
      :action="url"
      @on-close="onModalClose"
    />
    <ParkingAgentListDialog
      :id="entityId"
      :visible="modalAgentDialog"
      :width="1020"
      @on-close="onModalClose"
    />
  </div>
</template>

<script>
import TableWrapper from '@/components/table-wrapper'
import ParkingDialog from './dialog/parking-dialog'
import ParkingAgentListDialog from './parkingAgent'
import request from '@/utils/request'
import { getConfigItem } from '@/apis'
import { getLabelByCode, getLinkTextStyle } from '@/utils/util'
import { isAdmin, hasPermission } from '@/utils/app'

export default {
  name: 'Parking',
  components: {
    TableWrapper,
    ParkingDialog,
    ParkingAgentListDialog
  },
  data() {
    return {
      url: this.$config.apiContextPath + '/parking',
      modalForm: false,
      modalDelConfirm: false,
      modalAgentDialog: false,
      entityId: 0,
      modCount: 0,
      timeout: 30000,
      entityName: ''
    }
  },
  computed: {
    addPermited() { return isAdmin() || hasPermission('PEM_GARAGE_DATA_ADD') },
    deletePermitted() { return isAdmin() || hasPermission('PEM_GARAGE_DATA_DELETE') },
    updatePermitted() { return isAdmin() || hasPermission('PEM_GARAGE_DATA_UPDATE') },
    showAgentPermitted() { return isAdmin() || hasPermission('PEM_GARAGE_AGENT_LIST_READ') },
    offsetHeight() {
      return 280
    },
    formFields() {
      return {
        action: '',
        fields: [
          { label: '车库名', placeholder: '请输入车库名...', name: 'name', width: 'auto', type: 'input' },
          { label: '车库类型', placeholder: '请选择车库类型...', name: 'type', width: '140px', type: 'select', options: this.$config.parkingTypes },
          { label: '运营模式', placeholder: '请选择运营模式...', name: 'businessType', width: '140px', type: 'select', options: this.$config.parkingBusinessType }
          // { label: '终端序列号', placeholder: '请输入终端序列号...', name: 'serialNumber', width: 'auto', type: 'input' }
          // { label: '终端地址', placeholder: '请输入终端地址...', name: 'address', width: 'auto', type: 'input' }
        ]
      }
    },
    columns() {
      const _this = this
      return [
        { title: '选择', type: 'selection', width: 60, align: 'center', key: '_selection', disabled: true },
        { title: '编号', align: 'left', key: 'id', width: 80, sortable: true, ellipsis: true, tooltip: true },
        { title: '车库名', align: 'left', key: 'name', width: 230, sortable: true, ellipsis: true, tooltip: true },
        { title: '车库类型', align: 'center', key: 'type', sortable: true, width: 120, ellipsis: true, tooltip: true,
          render: (h, params) => {
            const matched = _this.$config.parkingTypes.find(t => params.row.type === t.value)
            return h('span', {}, matched ? matched.title : '---')
          }
        },
        { title: '开放绑定', align: 'center', key: 'isOpen', width: 120, sortable: true, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {
              style: { color: params.row.isOpen ? 'green' : 'red' }
            }, getLabelByCode(params.row.isOpen ? 1 : 0, this.$config.parkingOpenTypes))
          }
        },
        { title: '车库标志', align: 'center', key: 'isFresh', sortable: true, width: 120, ellipsis: true, tooltip: true,
          render: (h, params) => {
            const matched = _this.$config.parkingFreshTypes.find(t => (params.row.isFresh | 0) === t.value)
            return h('span', {}, matched ? matched.title : '---')
          }
        },
        { title: '缓冲月份', align: 'center', key: 'bufferMonths', sortable: true, width: 120, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {}, params.row.bufferMonths || '---')
          }
        },
        { title: '运行模式', align: 'center', key: 'businessType', sortable: true, width: 120, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {}, getLabelByCode(params.row.businessType, this.$config.parkingBusinessType))
          }
        },
        { title: '省份', align: 'center', key: 'province', sortable: true, width: 110, ellipsis: true, hidden: true,
          render: (h, params) => {
            return h('span', {}, params.row.province || '---')
          }
        },
        { title: '城市', align: 'center', key: 'city', sortable: true, width: 110, ellipsis: true, hidden: true,
          render: (h, params) => {
            return h('span', {}, params.row.city || '---')
          }
        },
        { title: '县区', align: 'center', key: 'district', sortable: true, width: 110, ellipsis: true, hidden: true,
          render: (h, params) => {
            return h('span', {}, params.row.district || '---')
          }
        },
        { title: '容量', align: 'center', key: 'capacity', width: 110, sortable: true, ellipsis: true, tooltip: true, hidden: false },
        // { title: '序列号', align: 'center', key: 'serialNumber', sortable: true, ellipsis: true, tooltip: true },
        { title: '运营日期', align: 'center', key: 'onlineDate', width: 120, sortable: true, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {}, params.row.onlineDate || '--')
          }
        },
        { title: '终端数', align: 'center', key: 'agentNum', width: 120, sortable: true, ellipsis: true, tooltip: true },
        { title: '开门次数', align: 'center', key: 'openingTimes', width: 120, sortable: true, ellipsis: true, tooltip: true },
        { title: '浮动IP', align: 'center', sortable: true, width: 160, key: 'floatingIp', ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {}, params.row.floatingIp || '---')
          }
        },
        // { title: '排序', align: 'center', key: 'sort', sortable: true, ellipsis: true, tooltip: true },
        // { title: '车辆号段', align: 'center', key: '_segment', sortable: true, ellipsis: true, tooltip: true, width: 190,
        //   render: (h, params) => {
        //     return h('span', {
        //       style: { }
        //     }, getParkingSegmentRange(parseInt(params.row.startSegment), parseInt(params.row.capacity)))
        //   }
        // },
        // {
        //   title: '号段剩余量', key: '_remained', align: 'center', width: 120,
        //   render: (h, params) => {
        //     return h('Progress', {
        //       props: {
        //         status: 'active',
        //         // strokeColor: ['#108ee9', '#87d068'],
        //         textInside: true,
        //         percent: parseFloat((((params.row.capacity - params.row.segmentOccupied) / params.row.capacity) * 100).toFixed(2))
        //       }
        //     })
        //   }
        // },
        // { title: '终端地址', align: 'center', key: 'address', sortable: true, width: 120 },
        { title: '同步时间', align: 'center', sortable: true, width: 160, key: 'syncTime', ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {}, params.row.syncTime || '---')
          }
        },
        { title: '创建时间', align: 'center', sortable: true, key: 'registrationTime', width: 160, ellipsis: true, tooltip: true },
        // { title: '更新时间', align: 'center', sortable: true, key: 'lastModifiedTime', ellipsis: true, tooltip: true,
        //   render: (h, params) => {
        //     return h('span', {}, params.row.lastModifiedTime || '---')
        //   }
        // },

        // { title: '同步时间', align: 'center', sortable: true, width: 160, key: 'syncTime',
        //   render: (h, params) => {
        //     return h('span', {}, params.row.syncTime || '---')
        //   }
        // },
        // { title: '同步状态', align: 'center', key: 'syncStatus', width: 120, sortable: true,
        //   render: (h, params) => {
        //     return h('span', {
        //       style: { color: params.row.syncStatus === 1 ? 'green' : 'red' }
        //     }, params.row.syncStatus === 1 ? '已同步' : '未同步')
        //   }
        // },
        { title: '操作', align: 'center', width: 250, key: '_actions', disabled: true, fixed: 'right',
          render: (h, params) => {
            const _this = this
            return h('div', [
              h('a', {
                style: getLinkTextStyle(_this.showAgentPermitted),
                on: {
                  click: () => {
                    if (params.row.id && _this.showAgentPermitted) {
                      this.showParkingAgentModalDialog(params.row.id, params.row.name)
                    }
                  }
                }
              }, [
                h('i', { class: { 'fas': true, 'fa-laptop': true, 'cell-icon-link': true }}),
                h('span', {
                  domProps: {
                    title: _this.showAgentPermitted ? '配置车库终端' : '您没有权限配置车库终端'
                  }
                }, '终端')
              ]),
              h('Dropdown', {
                props: { trigger: 'hover', placement: 'bottom' },
                on: {
                  'on-click': (name) => {
                    if (params.row.id && params.row.syncStatus !== 1) {
                      this.onDropdownItemClick(name, params.row)
                    }
                  }
                }
              }, [
                h('DropdownItem', { style: { color: '#126D91' }}, [
                  h('i', { class: { 'fas': true, 'fa-cloud-download-alt': true, 'cell-icon-link': true }}),
                  '同步',
                  h('Icon', { props: { type: 'ios-arrow-down' }})
                ]),
                h('DropdownMenu', { slot: 'list' }, [
                  h('DropdownItem', {
                    props: { name: 'sync_members' }
                  }, [
                    h('i', { class: { 'fas': true, 'fa-user': true, 'cell-icon-link': true }}),
                    h('span', {
                      domProps: {
                        title: params.row.syncStatus !== 1 ? '同步车辆用户' : '车辆用户已同步'
                      },
                      style: { width: '100px', display: 'inline-block', textAlign: 'left' }
                    }, '同步车辆用户')
                  ]),
                  h('DropdownItem', {
                    props: { name: 'sync_admins' }
                  }, [
                    h('i', { class: { 'fas': true, 'fa-user-cog': true, 'cell-icon-link': true }}),
                    h('span', {
                      domProps: {
                        title: params.row.syncStatus !== 1 ? '同步系统管理员' : '系统管理员已同步'
                      },
                      style: { width: '100px', display: 'inline-block', textAlign: 'left' }
                    }, '同步系统管理员')
                  ]),
                  h('DropdownItem', {
                    props: { name: 'sync_logs' }
                  }, [
                    h('i', { class: { 'fas': true, 'fa-user-cog': true, 'cell-icon-link': true }}),
                    h('span', {
                      domProps: {
                        title: '拉取车库日志'
                      },
                      style: { width: '100px', display: 'inline-block', textAlign: 'left' }
                    }, '拉取车库日志')
                  ])
                ])
              ]),
              h('a', {
                style: getLinkTextStyle(_this.updatePermitted),
                on: {
                  click: () => {
                    if (params.row.id && _this.updatePermitted) {
                      this.showFormModalDialog(params.row.id)
                    }
                  }
                }
              }, [
                h('i', { class: { 'fas': true, 'fa-edit': true, 'cell-icon-link': true }}),
                h('span', {}, '编辑')
              ]),
              h('a', {
                style: getLinkTextStyle(_this.deletePermitted),
                on: {
                  click: () => {
                    if (params.row.id && _this.deletePermitted) {
                      this.showDelModalDialog(params.row.id, params.row.name)
                    }
                  }
                }
              }, [
                h('i', { class: { 'fas': true, 'fa-trash': true, 'cell-icon-link': true }}),
                h('span', {
                  domProps: {
                    title: _this.deletePermitted ? '删除车库' : '您没有权限删除车库'
                  }
                }, '删除')
              ])
            ])
          }
        }
      ]
    }
  },
  methods: {
    showFormModalDialog: function(id = '') {
      this.entityId = id ? parseInt(id) : 0
      this.modalForm = true
    },
    async getParkingSyncTimeout() {
      const res = await getConfigItem(this.$config.apiContextPath + '/config', 'NS_SYSTEM', 'SYNC_PARKING_TIMEOUT')
      if (res.data && res.data.content.length > 0) {
        try {
          const configItem = res.data.content[0]
          this.timeout = parseInt(configItem.value)
        } catch (err) {
          console.log('Invalid timeout')
        }
      }
    },
    async syncParking(isAdminSync, id, name) {
      if (!id) {
        this.$Notice.error({ title: '车库ID不能为空' })
        return
      }
      const _this = this
      await this.getParkingSyncTimeout()
      const _target = isAdminSync ? '管理员' : '用户'
      this.$Modal.confirm({
        title: '确认同步车库' + _target + '么？',
        loading: true,
        render: (h, params) => {
          return h('ul', { style: { padding: '10px 25px 0', fontSize: '9pt' }}, [h('li', {}, name)])
        },
        onOk: function() {
          const _that = this
          const _path = isAdminSync ? '/sync/parking/' + id + '/admins' : '/sync/parking'
          request({
            url: this.$config.apiContextPath + _path,
            data: [id],
            timeout: _this.timeout,
            method: 'POST'
          }).then(res => {
            this.$Notice.success({
              title: '数据同步成功',
              desc: '车库 `' + name + '` ' + _target + '据同步成功!'
            })
            _this.modCount = _this.modCount + 1
            this.$Modal.remove()
          }).catch(error => {
            this.$Notice.error({
              title: '数据同步失败',
              desc: '车库 `' + name + '` ' + _target + '数据同步失败, 错误信息: ' + error
            })
            _that.buttonLoading = false
          })
        }
      })
    },
    async showSyncAdminsModalDialog(id, name) {
      await this.syncParking(true, id, name)
    },
    async showSyncMembersModalDialog(id, name) {
      await this.syncParking(false, id, name)
    },
    showParkingAgentModalDialog: function(id, name) {
      this.entityId = id ? parseInt(id) : 0
      this.modalAgentDialog = true
    },
    onDropdownItemClick(name, item) {
      if (name === 'sync_members') {
        this.showSyncMembersModalDialog(item.id, item.name)
      } else if (name === 'sync_admins') {
        this.showSyncAdminsModalDialog(item.id, item.name)
      } else if (name === 'sync_logs') {
        this.showSyncParkingLogs(item.id, item.name)
      }
    },
    showSyncParkingLogs(id, name) {
      const _this = this
      this.$Modal.confirm({
        title: '确认拉取车库日志么？',
        loading: true,
        render: (h, params) => {
          return h('ul', { style: { padding: '10px 25px 0' }}, [h('li', {}, name)])
        },
        onOk: function() {
          const _that = this
          request({
            url: this.$config.apiContextPath + '/sync/parking/' + id + '/logs',
            method: 'POST'
          }).then(res => {
            this.$Notice.success({
              title: '拉取成功',
              desc: '车库 `' + name + '` 日志拉取成功!'
            })
            _this.modCount = _this.modCount + 1
            this.$Modal.remove()
          }).catch(error => {
            this.$Notice.error({
              title: '拉取失败',
              desc: '车库 `' + name + '` 日志拉取失败, 错误信息: ' + error
            })
            _that.buttonLoading = false
          })
        }
      })
    },
    showOpenDoorModalDialog: function(name, address) {
      const _this = this
      this.$Modal.confirm({
        title: '确认进行远程开闸么？',
        loading: true,
        render: (h, params) => {
          return h('ul', { style: { padding: '10px 25px 0' }}, [h('li', {}, name)])
        },
        onOk: function() {
          const _that = this
          request({
            url: this.$config.apiContextPath + '/sync/cmd',
            method: 'POST',
            data: {
              address: address,
              cmd: 'OPEN_GATE'
            }
          }).then(res => {
            this.$Notice.success({
              title: '开闸成功',
              desc: '车库 `' + name + '` 开闸成功!'
            })
            _this.modCount = _this.modCount + 1
            this.$Modal.remove()
          }).catch(error => {
            this.$Notice.error({
              title: '开闸失败',
              desc: '车库 `' + name + '` 开闸失败, 错误信息: ' + error
            })
            _that.buttonLoading = false
          })
        }
      })
    },
    showDelModalDialog: function(id, name) {
      const _this = this
      this.$Modal.confirm({
        title: '确认删除车库信息么？',
        loading: true,
        render: (h, params) => {
          return h('ul', { style: { padding: '10px 25px 0' }}, [h('li', {}, name)])
        },
        onOk: function() {
          const _that = this
          request({
            url: _this.url + '/' + id,
            method: 'DELETE'
          }).then(res => {
            this.$Notice.success({
              title: '数据删除成功',
              desc: '车库 `' + name + '` 删除成功!'
            })
            _this.modCount = _this.modCount + 1
            this.$Modal.remove()
          }).catch(error => {
            this.$Notice.error({
              title: '数据删除失败',
              desc: '车库 `' + name + '` 删除失败, 错误信息: ' + error
            })
            _that.buttonLoading = false
          })
        }
      })
    },
    onModalClose: function(changed) {
      this.entityId = 0
      this.entityName = ''
      this.modalForm = false
      this.modalDelConfirm = false
      this.modalAgentDialog = false
      if (changed) {
        this.modCount = this.modCount + 1
      }
    },
    onBatchDeleteDone: function(selections) {
      this.modCount = this.modCount + 1
    }
  }
}
</script>

